import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { CircularProgress, Grid } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { gridSizeMdLg6, ROUTER_PATHS, useLoaders } from "@/shared";
import { CustomColorPicker, SingleIconButton, SingleTableBoxScene } from "@/shared/components/ui";
import { usePlanificadorStore } from "@/store/erp";
import Close from "@mui/icons-material/Close";
import { useAuthStore } from "@/store/auth";
import { BlockUnblockTime } from "../../shared/components";
import { useEmpleadoStore } from "@/store/erp/empleado";
import { getUserById, useFetchUpdateUser } from "@/shared/actions/erp";
import { Refresh } from "@mui/icons-material";
import { toast } from "react-toastify";
export interface PlanificadorCalendarPageProps { }

const PlanificadorCalendarPage: React.FC<
  PlanificadorCalendarPageProps
> = () => {
  const { id_flota } = useParams(); // id del planificador
  const returnUrlPlanificadoresPage =
    ROUTER_PATHS.mantenimientoOperaciones.planificadorNav;

  /////* global state ------------------
  const selectedPlanificador = usePlanificadorStore(
    (s) => s.selectedPlanificador
  );
  const setIsOpenCustomBlockTime = usePlanificadorStore(
    (s) => s.setIsOpenCustomBlockTime
  );
  const setIsOpenCustomUnblockTime = usePlanificadorStore(
    (s) => s.setIsOpenCustomUnblockTime
  );
  const handleStartPlanificador = usePlanificadorStore(
    (s) => s.handleStartPlanificador
  );
  const handleChangeDatePicker = usePlanificadorStore(
    (s) => s.handleChangeDatePicker
  );
  const valueDatePicker = usePlanificadorStore((s) => s.valueDatePicker);
  const selectedFlota = usePlanificadorStore((s) => s.selectedFlota);
  const maxDate = usePlanificadorStore((s) => s.maxDate);
  const minDate = usePlanificadorStore((s) => s.minDate);
  const isLoadingCalender = usePlanificadorStore((s) => s.isLoadingCalender);
  const user = useAuthStore((s) => s.user);
  const empladoColor = useEmpleadoStore(s => s.empladoColor)
  const { mutateAsync: mutateAsyncUser, isPending: isPendingUser } = useFetchUpdateUser({})

  useEffect(() => {
    if (!id_flota) return;
    handleStartPlanificador(id_flota);
  }, []);


  useLoaders(isPendingUser)

  return (
    <SingleTableBoxScene
      title={`📅 Planificador Flota: 
        ${isLoadingCalender
          ? "—"
          : selectedFlota?.nombre}`
      }
      enableRedirect={true}
      urlRedirect={returnUrlPlanificadoresPage}
      textRedirect={"Salir"}
      iconRedirect={<Close />}
    >
      <Grid item container xs={12} spacing={2} justifyContent={'center'} >
        {/* <span>{`${empladoColor.find(e => e.username == user?.username)?.color}`}</span> */}
        <CustomColorPicker
          initialColor={`${empladoColor.find(e => e.username == user?.username)?.color ?? '#000000'}`}
          onClick={async (color) => {

            const respUser = await getUserById(user!.user_id!.toString())

            if (respUser.code === 200) {

              const resp = await mutateAsyncUser({
                id: user?.user_id!,
                data: {
                  email: user?.email,
                  username: user?.username!,
                  color: color,
                  grupos: respUser.data.groups?.map(e => e.id)
                } as any,
              })


              if (resp.code === 200)
                window.location.reload()
            }
          }}
        />


        <Grid item container {...gridSizeMdLg6} justifyContent={"end"}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="es"
            localeText={
              esES.components.MuiLocalizationProvider.defaultProps.localeText
            }
          >
            <DatePicker
              label="Planificar para fecha:"
              minDate={minDate}
              maxDate={maxDate}
              value={valueDatePicker}
              onChange={(date) => {
                handleChangeDatePicker(date);
              }}
            />
          </LocalizationProvider>

          <SingleIconButton
            startIcon={<LockIcon />}
            label="Bloqueo por rango de fechas"
            color="warning"
            onClick={() => {
              setIsOpenCustomBlockTime(true);
            }}
          />
          <SingleIconButton
            startIcon={<LockOpenIcon />}
            label="Desbloqueo por rango de fechas"
            color="success"
            onClick={() => {
              setIsOpenCustomUnblockTime(true);
            }}
          />

          <SingleIconButton
            startIcon={<Refresh />}
            label="Actualizar"
            color="primary"
            onClick={() => {

              if (!selectedFlota) {
                toast.info('Seleccione una flota');
                return
              }
              handleStartPlanificador(selectedFlota.id_flota!)
            }}
          />
        </Grid>

        {/* ============ BIG CALENDAR COMPONENT ============ */}

        {!isLoadingCalender ? (
          <BlockUnblockTime />
        ) : (
          <Grid item style={{ margin: "100px 0px" }}>
            <CircularProgress />
          </Grid>
        )}

        {!selectedPlanificador && !isLoadingCalender && (
          <Grid item style={{ margin: "100px 0px" }}>
            Lo sentimos, no se ha encontrado una planificación para la fecha{" "}
            <b>{valueDatePicker?.format("YYYY-MM-DD")}.</b>
          </Grid>
        )}
      </Grid>
    </SingleTableBoxScene>
  );
};

export default PlanificadorCalendarPage;
